import { liveItems, type ItemDto, type ListDto, type ListsState, type MemberDto } from "@home/shared";
import { useSyncExternalStore } from "react";
import { api, streamEvents } from "./api.ts";
import { SyncEngine } from "./sync/engine.ts";
import { IdbSyncStorage, MemorySyncStorage, type SyncStorage } from "./sync/storage.ts";
import { initTelegram, userCacheKey } from "./telegram.ts";
import { invalidateRemote } from "./useRemote.ts";

// Telegram инициализируем до создания хранилища: от пользователя зависит имя базы.
initTelegram();

function createStorage(): SyncStorage {
  try {
    if (typeof indexedDB !== "undefined") return new IdbSyncStorage(`home-lists-${userCacheKey()}`);
  } catch {
    // приватный режим и т.п.
  }
  return new MemorySyncStorage();
}

// Поток событий списков заодно сообщает об изменениях денег — тогда обзор и операции перезагружаются.
// После переподключения (была без сети) тоже: пока соединения не было, что-то могли записать в боте.
let streamConnected = false;
export const engine = new SyncEngine(
  {
    ...api,
    streamEvents: (since, handlers, signal) =>
      streamEvents(
        since,
        {
          ...handlers,
          onReady: () => {
            handlers.onReady();
            if (streamConnected) invalidateRemote();
            streamConnected = true;
          },
          onFinance: invalidateRemote,
        },
        signal,
      ),
  },
  createStorage(),
);

export function useSync() {
  return useSyncExternalStore(engine.subscribe, engine.getView);
}

export function visibleLists(state: ListsState, templates: boolean): ListDto[] {
  return Object.values(state.lists)
    .filter((l) => !l.deletedAt && l.isTemplate === templates && l.status === "active")
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export function listItems(state: ListsState, listId: string): ItemDto[] {
  return liveItems(state, listId);
}

export function memberName(members: MemberDto[], userId: string | null): string {
  return members.find((m) => m.userId === userId)?.displayName ?? "";
}
